import { InputField } from "components/TextInput"
import { useFormik } from "formik"
import * as Yup from "yup"
import React, { useState } from "react"
import { adminInvite } from "services/AdminUserService"
import AdminTable from "./Admin Table/AdminTable"

import { SelectField } from "components/SelectInput"
import { observer } from "mobx-react-lite"
import authStore from "mobx/AuthStore"
import DashboardHeader from "../shared/DashboardHeader"
import { Modal } from "antd"

const StaffComp = () => {
	const [addToggle, setAddToggle] = useState(false)


	const addBtnHandler = () => {
		setAddToggle(!addToggle)
	}


	const formik = useFormik({
		enableReinitialize: false,
		initialValues: {
			email: "",
			admin_role: ""
		},
		onSubmit: async (data, helpers) => {
			const res = await adminInvite(data)

			if (!res.error) {
				helpers.resetForm()
				setAddToggle(false)
			}
		},
		validationSchema: Yup.object({
			email: Yup.string().max(250).email().required().label("Email"),
			admin_role: Yup.string().max(50).required().label("Role")
		})
	})
	return (
		<section>
			<DashboardHeader title="BYSHELB ADMIN STAFF" back/>

			<section className="mt-16">
				<div>
						<Modal centered maskClosable={false} onCancel={addBtnHandler} open={addToggle} footer>
							<div>
								<p className="text-xl font-bold mb-3">Add Staff</p>
								<div>
									<form onSubmit={formik.handleSubmit}>
										<SelectField
											label="Choose Admin Role:"
											name="admin_role"
											id="admin_role"
											value={formik.values.admin_role}
											onBlur={formik.handleBlur}
											onChange={formik.handleChange}
											error={formik.errors.admin_role}
											visible={formik.touched.admin_role}
										>
											<option value="">Select role</option>
											<option value="es">Super admin</option>
											<option value="lo">Loan Officer</option>
											<option value="lph">Loan Processing Head</option>
											<option value="la">Auditor</option>
											<option value="acc">Accountant</option>
											<option value="blog">Blogger</option>
											<option value="fdo">Front Desk</option>
										</SelectField>
									
												<InputField
													label="Email"
													width="250px"
													type="email"
													name="email"
													id="email"
													value={formik.values.email}
													onBlur={formik.handleBlur}
													onChange={formik.handleChange}
													placeholder="Enter staff email"
													error={formik.errors.email}
													visible={formik.touched.email}
												/>
										<button className="px-6 py-2 rounded-lg bg-primary text-white mt-5" type="submit">{authStore.isLoading ? "Sending Invite..." : "Send Invitation"}</button>
									</form>
								</div>
							</div>
						</Modal>

				</div>
			</section>
			<div>
				<div>
					<AdminTable onAddStaff={() => addBtnHandler()} />
				</div>
			</div>
		</section>
	)
}

export default observer(StaffComp)
